/* istanbul ignore file */
import { Aggregators, AggregatorsNames, } from '../../services/logic-services/enums';
import { CheckBoxTriggerOperatorText, DropdownTriggerOperatorText, NumberTriggerOperatorText, SiteStateTriggerOperatorText, SiteStatusTriggerOperatorText, TriggerOperator } from '../enums';

export const WIDGET_OPERATOR_CONSTANTS = {
    NUMBER: [
        { id: TriggerOperator.HasValue, name: NumberTriggerOperatorText.HasValue },
        { id: TriggerOperator.NoValue, name: NumberTriggerOperatorText.NoValue },
    ],
    CHECKBOX: [
        { id: TriggerOperator.HasValue, name: CheckBoxTriggerOperatorText.HasValue },
        { id: TriggerOperator.NoValue, name: CheckBoxTriggerOperatorText.NoValue },
    ],
    DROPDOWN: [
        { id: TriggerOperator.Equal, name: DropdownTriggerOperatorText.Equal },
        { id: TriggerOperator.NotEqual, name: DropdownTriggerOperatorText.NotEqual },
        { id: TriggerOperator.HasValue, name: DropdownTriggerOperatorText.HasValue },
        { id: TriggerOperator.NoValue, name: DropdownTriggerOperatorText.NoValue },
    ],
    SITE_STATE: [
        { id: TriggerOperator.Equal, name: SiteStateTriggerOperatorText.Equal },
        { id: TriggerOperator.NotEqual, name: SiteStateTriggerOperatorText.NotEqual },
    ],
    SITE_STATUS: [
        { id: TriggerOperator.Equal, name: SiteStatusTriggerOperatorText.Equal },
        { id: TriggerOperator.NotEqual, name: SiteStatusTriggerOperatorText.NotEqual },
    ]
};

export const WIDGET_AGGREGATOR_CONSTANTS = [
    { id: Aggregators.Count, name: AggregatorsNames.Count },
    { id: Aggregators.Sum, name: AggregatorsNames.Sum },
    { id: Aggregators.Average, name: AggregatorsNames.Average },
];
